/**
 * Livacils Predictive Search
 * Shopify Predictive Search API with debounce
 */

(function () {
  'use strict';

  const input = document.querySelector('[data-predictive-search-input]');
  const results = document.querySelector('[data-predictive-search-results]');
  if (!input || !results) return;

  let debounceTimer = null;
  let abortController = null;

  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => search(input.value.trim()), 300);
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      results.innerHTML = '';
      return;
    }
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const first = results.querySelector('a');
      if (first) first.focus();
    }
  });

  async function search(query) {
    if (query.length < 2) {
      results.innerHTML = '';
      return;
    }

    if (abortController) abortController.abort();
    abortController = new AbortController();

    results.innerHTML = `
      <div style="padding:16px;text-align:center;color:var(--color-gray-400);font-size:var(--text-small)">
        Recherche...
      </div>`;

    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`;
      const res = await fetch(url, { signal: abortController.signal });

      if (!res.ok) throw new Error('Search failed');

      const data = await res.json();
      const products = data?.resources?.results?.products || [];

      if (products.length === 0) {
        results.innerHTML = `
          <p style="padding:16px;text-align:center;color:var(--color-gray-600);font-size:var(--text-small)">
            Aucun résultat pour "${escapeHtml(query)}"
          </p>`;
        return;
      }

      results.innerHTML = products.map((p) => renderResult(p)).join('');

    } catch (err) {
      if (err.name !== 'AbortError') {
        results.innerHTML = '';
      }
    }
  }

  function renderResult(product) {
    const imgSrc = product.image
      ? product.image.replace('.jpg', '_80x80_crop_center.jpg')
      : '';

    const price = product.price
      ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(
          parseInt(product.price, 10) / 100
        )
      : '';

    return `
      <a href="${product.url}" class="search-result-item" role="option">
        ${imgSrc
          ? `<img src="${imgSrc}" alt="${escapeHtml(product.title)}" width="56" height="56" loading="lazy">`
          : `<div style="width:56px;height:56px;background:var(--color-nude);flex-shrink:0"></div>`
        }
        <div class="search-result-item__info">
          <p class="search-result-item__title">${escapeHtml(product.title)}</p>
          ${price ? `<p class="search-result-item__price">${price}</p>` : ''}
        </div>
      </a>
    `;
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

})();
